<template>
  <v-select v-bind="{ ...$attrs, ...commonAttrs }" v-on="$listeners" @input="handleChange($event)">
    <template v-for="(_, scopedSlotName) in $scopedSlots" #[scopedSlotName]="slotData">
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>
    <template v-for="(_, slotName) in $slots" #[slotName]>
      <slot :name="slotName" />
    </template>
    <template #item="slotProps" v-if="!hasSlot('item')">
        {{ translatedItem(slotProps.item) }}
    </template>
    <template #selection="slotProps" v-if="!hasSlot('selection')">
        {{ translatedItem(slotProps.item) }}
    </template>
  </v-select>
</template>

<script>
import { capitalize, get } from 'lodash';
import hasSlot from '@/mixins/hasSlot';

export default {
  name: 'Select',
  inheritAttrs: false,
  mixins: [hasSlot],
  props: {
    translationPath: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      initialized: false,
    };
  },
  computed: {
    commonAttrs() {
      return {
        hideDetails: this.$attrs.hideDetails || 'auto',
        prependInnerIcon: this.$attrs.prependInnerIcon,
        clearable: Object.hasOwn(this.$attrs, 'clearable') ? this.$attrs.clearable : true,
      }
    },
    translatedItem() {
      return (item) => {
        const translated = this.translationPath 
          ? this.$t(`${this.translationPath}.${item}`)
          : get(item, this.$attrs['itemText'] || this.$attrs['item-text']) || item.text || item;
        
        //if no upper case in translation text, then capitalize it otherwise leave it as it is
        return !this.hasUpperCase(translated) ? this.capitalize(translated) : translated;
      };
    },
  },
  methods: {
    capitalize,
    get,
    handleChange(val) {
      const value = this.$attrs?.items?.find(x => parseInt(x?.id) == parseInt(val)) || val;
      this.$emit('value:loaded', value);
      if (this.initialized) {
        this.$emit('value:change', value);
      } else {
        this.$emit('value:initialized', value);
        this.initialized = true;
      }
    },
    hasUpperCase(str) {
      if (typeof str !== 'string') return false;
      return str !== str.toLowerCase();
    }
  },
}
</script>
<style lang="css" scoped>
/deep/ .v-select__selections > div {
  width: 100%;
}
/deep/ .v-select__selections > [id^="input-"]:not([placeholder]) {
  display: none;
}
</style>